/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Credits_RemainingInputs */

const en_admin_credits_remaining = /** @type {(inputs: Admin_Credits_RemainingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remaining`)
};

/**
* | output |
* | --- |
* | "Remaining" |
*
* @param {Admin_Credits_RemainingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_credits_remaining = /** @type {((inputs?: Admin_Credits_RemainingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Credits_RemainingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_credits_remaining(inputs)
});
export { admin_credits_remaining as "admin.credits.remaining" }